export const commonTranslations = {
  ru: {
    'common.cancel': 'Отмена',
    'common.back': 'Назад',
    'common.done': 'Готово',
    'common.close': 'Закрыть',
    'common.confirm': 'Подтвердить',
    'common.loading': 'Загрузка…',
    'common.loadingData': 'Загрузка данных…',
    'common.all': 'Все',
    'common.date': 'Дата',
    'common.amount': 'Сумма',
    'common.direction': 'Направление',
    'common.direction.shortHeader': 'Д/К',
    'common.currency': 'Валюта',
    'common.status': 'Статус',
    'common.action': 'Действие',
    'common.reason': 'Причина',
    'common.code': 'Код',
    'common.group': 'Группа',
    'common.description': 'Описание',
    'common.empty.title': 'Нет данных',
    'common.empty.description': 'Пока нет записей для отображения.',
    'common.direction.debit': 'Списание',
    'common.direction.credit': 'Поступление',
    'common.direction.shortDebit': 'Д',
    'common.direction.shortCredit': 'К',
  },
  en: {
    'common.cancel': 'Cancel',
    'common.back': 'Back',
    'common.done': 'Done',
    'common.close': 'Close',
    'common.confirm': 'Confirm',
    'common.loading': 'Loading…',
    'common.loadingData': 'Loading data…',
    'common.all': 'All',
    'common.date': 'Date',
    'common.amount': 'Amount',
    'common.direction': 'Direction',
    'common.direction.shortHeader': 'D/C',
    'common.currency': 'Currency',
    'common.status': 'Status',
    'common.action': 'Action',
    'common.reason': 'Reason',
    'common.code': 'Code',
    'common.group': 'Group',
    'common.description': 'Description',
    'common.empty.title': 'No data',
    'common.empty.description': 'There are no records to display yet.',
    'common.direction.debit': 'Debit',
    'common.direction.credit': 'Credit',
    'common.direction.shortDebit': 'D',
    'common.direction.shortCredit': 'C',
  },
  id: {
    'common.cancel': 'Batal',
    'common.back': 'Kembali',
    'common.done': 'Selesai',
    'common.close': 'Tutup',
    'common.confirm': 'Konfirmasi',
    'common.loading': 'Memuat…',
    'common.loadingData': 'Memuat data…',
    'common.all': 'Semua',
    'common.date': 'Tanggal',
    'common.amount': 'Jumlah',
    'common.direction': 'Arah',
    'common.direction.shortHeader': 'D/K',
    'common.currency': 'Mata uang',
    'common.status': 'Status',
    'common.action': 'Tindakan',
    'common.reason': 'Alasan',
    'common.code': 'Kode',
    'common.group': 'Grup',
    'common.description': 'Deskripsi',
    'common.empty.title': 'Tidak ada data',
    'common.empty.description': 'Belum ada data untuk ditampilkan.',
    'common.direction.debit': 'Debit',
    'common.direction.credit': 'Kredit',
    'common.direction.shortDebit': 'D',
    'common.direction.shortCredit': 'K',
  },
} as const;
